import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  mpSlots: {},
  meetings: {},
  times: {},
  days: [],
  meetingDaysMap: {},
  meetingDaysMapForMobile: {},
  meetingSponsors: [],
  availableSlotsModalId: null,
};
const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
